import { useMount } from 'react-use';

import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { useInteractiveTableContext } from '@dreryk/react-components';

import { isEmpty } from '~libs.typescript';

import { EmergencyNotificationSmsConfigurationContactPersonValue } from '../EmergencyNotificationSmsConfigurationContactPersonsField.types';

type EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableSynchronizationProps = {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableSynchronization = (
   props: EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableSynchronizationProps
): null => {
   const { addRow, getValues } = useInteractiveTableContext<EmergencyNotificationSmsConfigurationContactPersonValue>();

   useMount(() => {
      if (isEmpty(getValues())) {
         const defaultValue = props.emergencyNotificationConfiguration.smsConfiguration.contactPersons.map(
            (contactPerson) => ({
               name: contactPerson.name,
               phoneNumber: contactPerson.phoneNumber,
            })
         );
         addRow(defaultValue, 'append');
      }
   });

   return null;
};
